/**
 * Created by danielg on 9/9/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var _queueModel;
    var _callbacks;
    var _logger;

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////
    var QueueRealTimeAdapter = BaseController.extend(function QueueRealTimeAdapter(options) {
        _logger = this.logger || WebAgentLogger.getLogger(this.applicationType);
        if (options) {
            _setModel(options.model);
            _setCallbacks(options);
        }
        if (_queueModel) {
            // Set binds here
            _queueModel.bind('agent.isMaxChats', _maxChatsUpdated, this);
            _queueModel.bind('agent.acd', _updateAcdValues, this);
            _queueModel.bind('agent.connectionState', _handleAppserverConnectionStatusChanged, this);
        }
    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    QueueRealTimeAdapter.prototype.applicationType = 'QueueRealTimeAdapter';
    QueueRealTimeAdapter.prototype.ringingCount = 0;
    QueueRealTimeAdapter.prototype.maxChatsReached = false;
    QueueRealTimeAdapter.prototype.isConnected = false;
    QueueRealTimeAdapter.prototype.isAutoAcceptEnabled = false;
    QueueRealTimeAdapter.prototype.isTimerEnabled = false;

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    /**
     * Returns true if there are chats in the queue and the service is connected and max chats is not reached
     * @returns {boolean} True if there are chats in the queue and the service is connected and max chats is not reached
     */
    QueueRealTimeAdapter.prototype.canAcceptChat = function () {
        return this.hasChatsInQueue() && !this.maxChatsReached;
    };

    /**
     * Returns true if there are chats in the queue and the service is connected
     * @returns {boolean} True if there are chats in the queue and the service is connected
     */
    QueueRealTimeAdapter.prototype.hasChatsInQueue = function () {
        return this.ringingCount > 0 && this.isConnected;
    };

    /**
     * Accepts the first chat in the queue, if there are chats in the queue
     */
    QueueRealTimeAdapter.prototype.acceptChat = function () {
        if (this.canAcceptChat()) {
            var that = this;
            this.acceptTime = new Date().getTime();
            this.nextRingingCount = this.ringingCount - 1;
            var request = {
                success: function (data) {
                    _callAcceptSuccessCallback.call(that, data);
                    _updateRingingCount.call(this, {newValue: this.nextRingingCount, forcedByUI: true, acceptTime: that.acceptTime});
                    that.acceptTime = null;
                    that.nextRingingCount = null;
                    that = null;
                },
                error: function (data) {
                    if (data && data.error && data.error.data && data.error.data.error.internalCode === 36) {
                        that.logger.error("Can't accept chat. Max chat limitation.", "acceptChat");
                        that.logger.graph({name: 'maxChatsError'});
                    } else {
                        that.logger.error(data && data.error ? data.error.message : "Error in accept chat.", "acceptChat");
                        that.logger.graph({name: 'acceptChatError'});
                    }
                    that.acceptTime = null;
                    that.nextRingingCount = null;
                    that = null;
                    _callAcceptErrorCallback();
                },
                context: this
            };
            lpTag.WebAgent.agentController.acceptChat(request);
        }
    };

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////
    /**
     * Handles changes in the App Server connection state
     */
    function _handleAppserverConnectionStatusChanged(eventData) {
        var isAppserverConnected = lpTag.WebAgent.logicController.isConnectionStatusActive();
        if (isAppserverConnected !== this.isConnected) {
            this.isConnected = isAppserverConnected;
            _callIsConnectedCallback(isAppserverConnected);
        }
        if (isAppserverConnected) {
            this.connectionStateRenderRequired = true;
            _bindRingingCount.call(this);
        } else {
            _unbindRingingCount.call(this);
        }
    }

    /**
     * Binds to the ringing count
     */
    function _bindRingingCount() {
        _queueModel.bind('agent.ringingCount', _updateRingingCount, this);
    }

    /**
     * Unbinds from the ringing count
     */
    function _unbindRingingCount() {
        _queueModel.unbind('agent.ringingCount', _updateRingingCount, this);
    }

    /**
     * Updates the ringing count (can be forced by UI when we accept a chat and change the count internally)
     * @param event Contains the new value of the ringing count
     */
    function _updateRingingCount(event) {
        var oldRingingCount = this.ringingCount;
        var newRingingCount = (event && event.newValue) || 0;
        if (newRingingCount && this.isAutoAcceptEnabled ||
            this.ringingCount !== newRingingCount) {
            if (event.forcedByUI) {
                if (this.lastUpdate <= event.acceptTime) {
                    this.ringingCount = newRingingCount;
                } else {
                    return;
                }
            } else {
                this.ringingCount = newRingingCount;
            }
            this.lastUpdate = new Date().getTime();
            if (oldRingingCount !== this.ringingCount) {
                _callCountChangeCallback(newRingingCount);
            }
            if (this.hasChatsInQueue()) {
                _autoAcceptChat.call(this);
            }
        }
    }

    function _maxChatsUpdated(data) {
        if (data && typeof data.newValue !== 'undefined') {
            var oldValue = this.maxChatsReached;
            this.maxChatsReached = !!data.newValue;
            if (this.maxChatsReached !== oldValue) {
                _callMaxChatsChangeCallback(this.maxChatsReached);
            }
        }
    }

    /**
     * Auto accepts a chat if there are chats in the queue and auto accept is enabled
     */
    function _autoAcceptChat() {
        if (this.isAutoAcceptEnabled && this.canAcceptChat()) {
            _callAutoAcceptingCallback();
            this.acceptChat();
        }
    }

    /**
     * Updates if Auto accept is enabled according to the ACD config
     * @param data The ACD config
     */
    function _updateAcdValues(data) {
        if (typeof data.newValue !== "undefined") {
            _setAutoAccept.call(this, data.newValue.autoAnswering === "true");
            if (this.isAutoAcceptEnabled === false) {
                _setTimer.call(this, true, parseInt(data.newValue.awayTimeOut, 10));
            } else {
                _setTimer.call(this, false);
            }
        } else if (typeof data.removedValue !== "undefined") {
            _setAutoAccept.call(this, false);
            _setTimer.call(this, false);
            this.isTimerEnabled = false;
        }
    }

    /**
     * Sets isTimerEnabled and awayTimeOut to the given values, and acts accordingly
     * @param isEnabled {boolean} The new value for isTimerEnabled
     * @param time {number} The new value for awayTimeOut
     * @private
     */
    function _setTimer(isEnabled, time) {
        if (this.isTimerEnabled !== isEnabled || (time && this.awayTimeOut !== time)) {
            this.isTimerEnabled = isEnabled;
            this.awayTimeOut = time;
            _callTimerChangeCallback(this.isTimerEnabled, this.awayTimeOut);
        }
    }

    /**
     * Sets isAutoAcceptEnabled to the given value, and acts accordingly
     * @param isAutoAcceptEnabled {boolean} The new value
     * @private
     */
    function _setAutoAccept(isAutoAcceptEnabled) {
        if (this.isAutoAcceptEnabled !== isAutoAcceptEnabled) {
            this.isAutoAcceptEnabled = isAutoAcceptEnabled;
        }
        _autoAcceptChat.call(this);
    }

    /**
     * Sets the model
     * @param model - the model
     * @private
     */
    function _setModel(model) {
        if (model) {
            _queueModel = model;
        }
    }

    /**
     * Sets the callbacks
     * @param callbacksObj - the callbacks
     * @private
     */
    function _setCallbacks(callbacksObj) {
        if (callbacksObj) {
            _callbacks = callbacksObj;
        }
    }

    /**
     * Calls the isConnected callback if it exists
     * @param isConnected - The isConnected value to pass on to the callback
     * @private
     */
    function _callIsConnectedCallback(isConnected) {
        if (_callbacks && _callbacks.isConnected) {
            _callbacks.isConnected.call(_callbacks.context, isConnected);
        }
    }

    /**
     * Calls the countChange callback if it exists
     * @param newCount - The newCount value to pass to the callback
     * @private
     */
    function _callCountChangeCallback(newCount) {
        if (_callbacks && _callbacks.countChange) {
            _callbacks.countChange.call(_callbacks.context, newCount);
        }
    }

    /**
     * Calls the autoAccepting callback if it exists
     * @private
     */
    function _callAutoAcceptingCallback() {
        if (_callbacks && _callbacks.autoAccepting) {
            _callbacks.autoAccepting.call(_callbacks.context);
        }
    }

    /**
     * Calls the acceptSuccess callback if it exists
     * @param data - The data of the accept success containing visitorInfo and chatInfo
     * @private
     */
    function _callAcceptSuccessCallback(data) {
        if (_callbacks && _callbacks.acceptSuccess) {
            var toSend = {
                isAsyncMessaging: false,
                isAutoAccepted: this.isAutoAcceptEnabled
            };
            if (data) {
                if (data.visitorInfo && data.visitorInfo.visitorId) {
                    toSend.visitorId = data.visitorInfo.visitorId + '';
                }
                if (data.chatInfo && data.chatInfo.chatId) {
                    toSend.chatId = data.chatInfo.chatId + '';
                }
            }
            _callbacks.acceptSuccess.call(_callbacks.context, toSend);
        }
    }

    /**
     * Calls the acceptError callback if it exists
     * @private
     */
    function _callAcceptErrorCallback() {
        if (_callbacks && _callbacks.acceptError) {
            _callbacks.acceptError.call(_callbacks.context);
        }
    }

    /**
     * Calls the maxChatsChange callback if it exists
     * @param isMaxChatsReached {boolean} True if max chats is reached
     * @private
     */
    function _callMaxChatsChangeCallback(isMaxChatsReached) {
        if (_callbacks && _callbacks.maxChatsChange) {
            _callbacks.maxChatsChange.call(_callbacks.context, isMaxChatsReached);
        }
    }

    /**
     * Calls the timerChange callback if it exists
     * @param isTimerEnabled {boolean} True if the timer is enabled
     * @param awayTimeOut {number} The timeout for the timer
     * @private
     */
    function _callTimerChangeCallback(isTimerEnabled, awayTimeOut) {
        if (_callbacks && _callbacks.timerChange) {
            _callbacks.timerChange.call(_callbacks.context, isTimerEnabled, awayTimeOut);
        }
    }

    return QueueRealTimeAdapter;

});
